<script setup lang="ts">
import { defineProps,defineEmits, onUnmounted, onMounted, ref, reactive, watch, watchEffect} from "vue";
import AxiosVideoService from "../utils/axiosVideoService";
import { useLanguage } from "../utils/useLanguage";
import { useRouter } from 'vue-router';
import { isLogin, checkLoginStatus } from "../utils/useAuth";
const modalRef = ref<HTMLElement | null>(null)
defineExpose({ modalRef }) // 讓外部可以 access

const { t } = useLanguage();
const axiosVideoService = new AxiosVideoService();
const router = useRouter();

const emit = defineEmits(['update:status'])
const props = defineProps({  
    status: {
        type: Boolean,
        required: false,
    }
})
const modalSetting = reactive({
  status: false, // Modal Open or Close
});
watch(() => props.status, (newStatus) => {
  modalSetting.status = newStatus;
});
const loadingInfo = reactive({
    status: false,
    title: "Video processing",
})
const modalInfo = reactive({
    type: "alert",
    status: false,
    title: "Fail!",
    content: t('subtitleGenerationFailed'),
    msg: "chatnow"
})



let yt_url = ref()
function isValidUrl(url: string) {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}
async function createVideo(url: string){
    loadingInfo.status = true

    if(!isLogin){
        loadingInfo.status = false
        modalInfo.status = true
        modalInfo.msg = "chatnow"
        modalInfo.title = "I'm sorry!"
        modalInfo.content = 'To use the Mimir Watch, please first Sign up or Login!'
        
        return
    }
    loadingInfo.title = "Waiting for upload";

    loadingInfo.status = true
    if(!isValidUrl(url)){
        loadingInfo.status = false

        modalInfo.status = true
        modalInfo.type = "alert"

        modalInfo.msg = 'confirm'
        modalInfo.title = 'Error'
        modalInfo.content = 'Please enter the correct URL.'
        
        return
    }
    

    console.log("createVideo")
    // progressBar()
    await axiosVideoService.createVideo(localStorage.token, url, learning_language.value, site_language.value )
    .then((res: any) => {
        loadingInfo.status = false
        yt_url.value = ""

      
        console.log("createVideo success", res.data)
        if(res.data.transcribe_status == 'pending' ||res.data.transcribe_status == 'not_started'){
            allPending.value.push({ ...res.data, progress: 0, state: res.data.transcribe_status });
            
        }else if(res.data.transcribe_status == 'fail'){
            // 轉譯失敗
            let reason = res.data.transcribe_fail_reason || '';
            let message = '';

            if (
            reason.includes('Video unavailable. The uploader has not made this video available in your country')
            ) {
            message = 'Invalid video.';
            } else if (
            reason.includes('Sign in to confirm you\'re not a bot') ||
            reason.includes('terminated') ||
            reason.includes('QueuePool limit') ||
            reason.includes('The downloaded file is empty') ||
            reason.includes('Requested format is not available') ||
            reason.includes('Cannot copy out of meta tensor') ||
            reason.includes('English to English translation is not supported')
            ) {
            message = 'Try it again.';
            } else {
            message = reason;
            }

            transcriptInfo(false, message, res.data.id);
            
        }else if(res.data.transcribe_status == 'success'){
            // 已轉譯過的影片
            transcriptInfo(true, 'success', res.data.id)
            allPending.value.push({ ...res.data, progress: 100, state: res.data.transcribe_status });
        }


        
    })
    .catch((res: any) => {
        loadingInfo.status = false
        console.log('createVideo fail', res.response.status)

        // pendingInfo.status = false
        modalInfo.status = true
        modalInfo.type = "alert"

        if(res.response.status == 401){
            
            modalInfo.msg = "subscribe"
            modalInfo.title = t("Oops!")
            modalInfo.content = t("Please login first!")
        }else{
            
            modalInfo.msg = "confirm"
            modalInfo.title = t("Video processing failed!")
            modalInfo.content = t("Please ensure the video language is either English or Spanish, and verify that there is no silence longer than one minute at the beginning of the video.")
        }

        console.log('video failed',res.response.data.detail);
    })
    
}
/* 上傳影片 */
function goToVideo(){

    const url = router.resolve({ name: 'Upload', params: { id: vid.value } }).href;
    window.open(url, '_blank'); // 開啟新視窗


}
function goToUpload(video_id: string){

    const url = router.resolve({ name: 'Upload', params: { id: video_id } }).href;
    window.open(url, '_blank'); // 開啟新視窗


}


/* All Video List 所有影片 */
let allSubmittedVideo: any = ref([]);
let videoCount: any = ref(10);
let videoPage: any = ref();
let cVideoPage: any = ref();

interface VideoItem {
    id: string;
    title: string;
    video_url: string;
    progress: number;
    items: any;
    state: string; // 轉譯狀態
}
const allPending = ref<VideoItem[]>([]);

function getAllVideoList(page: number, size: number){
    axiosVideoService.getVideoList(localStorage.token, page, size, learning_language.value)
    .then((res: any) => {
        videoPage.value = res.data.pages
        cVideoPage.value = res.data.page
        
        let videoArr:any = res.data.items
        // 按照時間排序
        videoArr = videoArr.sort(function (a:any, b:any) {
            return a.updated_at < b.updated_at ? 1 : -1;
        });
        // 只顯示成功的影片
        videoArr = videoArr.filter(function (value:any) {
            return value.transcribe_status == 'success';
        });

        // 所有已轉譯影片
        // allSubmittedVideo.value.push = videoArr
        
        for(let i = 0; i < videoArr.length; i++){
            allSubmittedVideo.value.push(videoArr[i])
        }

        // 還未轉譯完成的影片
        for(let i = 0; i < res.data.items.length; i++){
            // allVideo.value.push(videoArr[i])
            if(res.data.items[i].transcribe_status === "pending" ) {
                allPending.value.push({ ...res.data.items[i], progress:50, state: res.data.items[i].transcribe_status });
                startInterval(res.data.items[i].id)
            }else if(res.data.items[i].transcribe_status === "not_started"){
                allPending.value.push({ ...res.data.items[i], progress:0, state: res.data.items[i].transcribe_status });
                startInterval(res.data.items[i].id)
            }
        }



    })
    .catch((r: any) => {
        console.log('list video failed',r.data);
    }) 
}
/* 影片狀態確認 */
function checkVideoStatus(id: string) {

    axiosVideoService.getVideoById(id, '?include_transcript=false')
        .then((res: any) => {
            const videoStatus = res.data.transcribe_status;

            // 在 allPending 中找到對應的項目
            const videoItemIndex = allPending.value.findIndex((item: VideoItem) => item.id === id);
          

            if ((videoStatus === "pending" || videoStatus === "not_started") && videoItemIndex !== -1) {
                // 未開始或正在進行中開始計時器
                console.log('still pending');
            } else if (videoStatus === "success" && videoItemIndex !== -1) {
                // 轉譯成功
                console.log('final success');
                stopInterval(id);
                allPending.value[videoItemIndex].progress = 100;
                allPending.value[videoItemIndex].state = videoStatus;
                transcriptInfo(true, 'success', id)
                allPending.value = [...allPending.value];
            } else if (videoStatus === "fail" && videoItemIndex !== -1) {
                // 轉譯失敗
                stopInterval(id);
                let reason = res.data.transcribe_fail_reason || '';
                let message = '';

                if (
                reason.includes('Video unavailable. The uploader has not made this video available in your country')
                ) {
                message = 'Invalid video.';
                } else if (
                reason.includes('Sign in to confirm you\'re not a bot') ||
                reason.includes('terminated') ||
                reason.includes('QueuePool limit') ||
                reason.includes('The downloaded file is empty') ||
                reason.includes('Requested format is not available') ||
                reason.includes('Cannot copy out of meta tensor') ||
                reason.includes('English to English translation is not supported')
                ) {
                message = 'Try it again.';
                } else {
                message = reason;
                }

                transcriptInfo(false, message, res.data.id);

                allPending.value[videoItemIndex].progress = 0;
                allPending.value[videoItemIndex].state = videoStatus;
                allPending.value = [...allPending.value];
            }

        })
        .catch((res: any) => {
            console.log('get video status fail', res, id);
        });
}

const vid = ref("58ed503e-eee6-4f54-ac5d-2f0fe357e53c")
// 完成轉譯彈窗 Success Modal
function transcriptInfo(state:boolean, type: string, id: string){
    
    modalInfo.status = true

    if(state){
        modalInfo.type = ''        
    }else{
        modalInfo.type = 'alert'
    }
    
    if (type !== 'success') {
        modalInfo.title = t('Fail!')
        modalInfo.content = type
        modalInfo.msg = 'videofail'
    } else {
        modalInfo.title = t('Video processing done!')
        modalInfo.content = t('Video Transcripting Done!')
        modalInfo.msg = 'videosuccess'
    }

    vid.value = id
    
}

// 進度條 Progress
function startProgress(videoItem: VideoItem) {
    if (videoItem.progress >= 100) {
        return;
    }

    const intervalId = setInterval(() => {
        if (videoItem.progress < 99) {
            
            videoItem.progress = Math.min(99, Math.ceil(videoItem.progress + 1));
        } else if (videoItem.progress == 99) {
            videoItem.progress = 99;
            clearInterval(intervalId);
        }
    }, 1500);

    onUnmounted(() => clearInterval(intervalId));
}

/* 計時器 */
const intervalIds: { [key: string]: NodeJS.Timeout } = {};
function startInterval(id:string) {
    console.log(`Interval for ${id} already started`);
    if (intervalIds[id] !== undefined) return;
    intervalIds[id] = setInterval(() => {
        checkVideoStatus(id);
    }, 10000);
}
function stopInterval(id: string) {
    if (intervalIds[id] !== undefined) {
        clearInterval(intervalIds[id]);
        delete intervalIds[id];
    }
}

// 監聽 allPending 並為每個新項目啟動進度計算
watch(
    () => allPending.value.length,  // 只監聽 allPending 的長度變化
    (newLength, oldLength) => {
        if (newLength > oldLength) {
            const newItems = allPending.value.slice(oldLength); // 找到新增的項目
            newItems.forEach(videoItem => {
                console.log('here',videoItem)
                if(videoItem.state == 'success'){
                    // 已轉譯
                }else if(videoItem.state == 'not_started' || videoItem.state == 'pending'){
                    // 未開始或正在進行中開始計時器
                    if(videoItem.id){
                        startInterval(videoItem.id);

                    }
                    startProgress(videoItem);
                }
            });
        }
    }
);

const boolChange = () => {
    emit('update:status',false)
}
const learning_language = ref()
const site_language = ref()
onMounted(() => {
    checkLoginStatus()
    learning_language.value = localStorage.getItem('learningLanguage')
    site_language.value = localStorage.getItem('siteLanguage')

    getAllVideoList(1, videoCount.value); // 載入所有
})
</script>
<template >
 <div class="fixed bg-white-1 videoModal" :class="[props.status ? 'open': '']" ref="modalRef" >
    <div class="vHeader title-2 white-1 flex j-between bg-pr-200">{{ t('Your Video Transript') }}<div class="icon-close pointer white-1" @click="boolChange()"></div></div>

    <div class="vContent bg-white-1 scroll">
        <h2 class="title-1">{{ t('Upload a Youtube Video') }}</h2>
        <div class="p-20">
            <p>{{ t('Please enter the link to your YouTube video here: (Videos no more than 60 minutes)') }}</p>
            <form class="flex column j-center mt-10 mb-20">
                <label for=""></label>
                <div class="flex wrap rel gap-10">
                    <input id="yt_url" class="input search" type="text" v-model="yt_url" :placeholder="t('Please enter the link to your YouTube video here: (Videos no more than 60 minutes)')">
                    <input class="btn" :class="yt_url ? 'bg-red pointer': 'bg-black-3'" :value="t('Submit')" type="button" @click="createVideo(yt_url)" :disabled="!yt_url">
                </div>
            </form> 
        </div>
        
        <h2 class="title-1">{{ t('Video Transcript Processing') }}</h2>
        <div class="p-10">
            <div  class="videoItem" :class="item.state == 'success' ? 'pointer':''" v-for="item in allPending" :key="item.id"  @click="item.state == 'success' ? goToUpload(item.id) :''">
                <div class="flex a-center j-between">
                    <p class="content black-3">{{item.title ? item.title : item.video_url }}</p>
                    <div class="flex a-center gap-10">
                        <span class="font-2" :class="[item.state == 'success'? 'pr' : (item.state === 'fail' ? 'alert' : 'sd-color')]" v-if="item.state == 'success'">Success!</span>
                        <span class="font-2 sd-color" v-else-if="item.state == 'fail'">Fail!</span>
                        <span class="font-2 sd-color" v-else>Compiling {{ item.progress }}%</span>
                        <img class="s-15" :src="item.state === 'success' ? '/icon-checked.png' : (item.state === 'fail' ? '/icon-alert.png' : '/icon-warn.png')" alt="">

                    </div>
                </div>
                <div class="flex a-center gap-5">
                    <div class="vProgress"  :style="{backgroundImage: 'linear-gradient(to right, ' + (item.state == 'success' ? '#9747FF' : '#FFB805') + ' ' + item.progress + '%, #D0CECE 0)'}"></div>
    
                </div>
            </div>
        </div>
        <h2 class="title-1">{{ t('Your Video List') }}</h2>
        <div class="p-10">

            <ul  class="videoItem flex j-between a-center" :class="[item.transcribe_status == 'success' ? 'pointer': '']" v-for="item in allSubmittedVideo" :key="item.id" @click="item.transcribe_status == 'success' ? goToUpload(item.id) :''">
                <li class="flex a-center gap-10">
                    <span class="icon-play"></span>
    
                    <div>
                        <p class="content" :class="[item.transcribe_status == 'success' ? '': 'black-3']">{{ item.title ? item.title: item.video_url }}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="t-center ">
            <div class="btn capsule outline br-black black-1" @click="getAllVideoList((cVideoPage + 1), videoCount)" v-if="cVideoPage < videoPage ">{{ t('See More Video') }}</div>
        </div>


    </div>

</div>
<Modal :childFunction="goToVideo" v-model:type="modalInfo.type" v-model:title="modalInfo.title" v-model:content="modalInfo.content" v-model:status="modalInfo.status" v-model:msg="modalInfo.msg"/>
<Loading v-model:status="loadingInfo.status" v-model:title="loadingInfo.title"></Loading>


</template>
<style scoped>
@import '../assets/css_lib/themimir.css';

.videoModal{
    z-index: 999999;
    left: 50%;
    transform: translate(-50%, -50%);
    top: calc(100% + 50vh);
    transition: all .5s ease;
}
.videoModal.open{
    top: 50%;
}
.vHeader{
    padding: 16px;
    border-bottom: .0625rem solid #f3f3f3;
}
.vContent{
    padding: 20px 25px 50px;
    width: 80vw;
    height: calc(80vh - 130px);
}
@media all and (max-width: 540px) {
    .vHeader{
        height: 60px;
    }
    .vContent{
        width: 100vw;
        height: calc(100vh - 60px);
    }

}
@media (orientation: landscape) and (max-width: 960px) {
    .vContent{
        height: calc(90vh - 80px);

    }
}
.v-card{
    border-radius: 5px;
    padding: 20px;
}

.vProgress{
    width:100%;
    margin-top: 5px;
    height: 6px;
    border-radius: 7px;
}
</style>